<!-- WMS异常收货审核操作 -->
<template>
  <div>
    <el-drawer :close-on-press-escape="true" :visible.sync="dialogBox" :with-header="false"
      append-to-body custom-class="recepend_drawer_box" direction="ltr" size="100%">
      <div class="drawer_content">
        <!-- 顶部标题 -->
        <div class="drawer_title">
          <span>{{ isView ? '异常收货详情' : '异常收货审核' }}</span>
          <i class="el-icon-close" @click="closeBox"></i>
        </div>
        <!-- 内容区 -->
        <div class="drawer_body">
          <!-- 表单信息（主表数据） -->
          <el-form :model="dataInfo" :inline="true" size="mini" label-width="110px" class="info_form">
            <el-form-item label="业务类型">
              <el-input v-model="dataInfo.businessType" disabled></el-input>
            </el-form-item>
            <el-form-item label="单位编号">
              <el-input v-model="dataInfo.unitCode" disabled></el-input>
            </el-form-item>
            <el-form-item label="单位名称">
              <el-input v-model="dataInfo.unitName" disabled></el-input>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input v-model="dataInfo.orderNo" disabled></el-input>
            </el-form-item>
            <el-form-item label="制单人">
              <el-input v-model="dataInfo.createrName" disabled></el-input>
            </el-form-item>
            <el-form-item label="制单时间">
              <el-input :value="dataInfo.createTime ? $common.getLocalTime(dataInfo.createTime) : ''" disabled>
              </el-input>
            </el-form-item>
            <el-form-item label="WMS收货单号">
              <el-input v-model="dataInfo.rcode" disabled></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-input :value="getAuditStateName(dataInfo.auditState)" disabled></el-input>
            </el-form-item>
          </el-form>
          <div class="table_content_box title_box">明细</div>
          <!-- 明细表格 -->
          <el-table size="mini" stripe :data="detailList" border style="width: 100%" height="200"
            class="detail_table">
            <el-table-column align="center" prop="bgmName" label="商品名称" show-overflow-tooltip min-width="140">
            </el-table-column>
            <el-table-column align="center" prop="spec" label="规格" show-overflow-tooltip min-width="90">
            </el-table-column>
            <el-table-column align="center" prop="bgiAppnumber" label="批准文号" show-overflow-tooltip min-width="110">
            </el-table-column>
            <el-table-column align="center" prop="batchno" label="批号" show-overflow-tooltip min-width="90">
            </el-table-column>
            <el-table-column align="center" prop="manufacturer" label="生产厂家" show-overflow-tooltip min-width="130">
            </el-table-column>
            <el-table-column align="center" prop="recnum" label="数量" show-overflow-tooltip min-width="70">
            </el-table-column>
            <el-table-column align="center" prop="rejnum" label="拒收数量" show-overflow-tooltip min-width="80">
            </el-table-column>
            <el-table-column align="center" prop="qualitystatus" label="质量状态" show-overflow-tooltip min-width="80">
            </el-table-column>
            <el-table-column align="center" prop="expidate" label="有效期" show-overflow-tooltip min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.expidate">
                  {{ $common.getLocalTime(scope.row.expidate) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="prodate" label="生产日期" show-overflow-tooltip min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.prodate">
                  {{ $common.getLocalTime(scope.row.prodate) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="quaperson" label="责任人" show-overflow-tooltip min-width="90">
            </el-table-column>
            <el-table-column align="center" prop="recedesc" label="收货说明" show-overflow-tooltip min-width="120">
            </el-table-column>
          </el-table>
          <!-- 审核表单（仅审核模式显示） -->
          <el-form :model="sendDataInfo" label-position="top" class="audit_form" v-if="!isView">
            <el-form-item label="审批结果">
              <el-radio-group v-model="sendDataInfo.auditState">
                <el-radio-button :label="1">同意</el-radio-button>
                <el-radio-button :label="0">不同意</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="审批意见" prop="auditRemark"
              :rules="[{ required: auditRemarkRequired, message: '请输入审批意见', trigger: ['blur', 'change'] }]">
              <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="sendDataInfo.auditRemark"
                maxlength="200" show-word-limit>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 底部按钮 -->
        <div class="drawer_footer">
          <el-button @click="closeBox">{{ isView ? '关 闭' : '取 消' }}</el-button>
          <el-button v-if="!isView" type="primary" :loading="submitLoading"
            @click="submitDataAction()">审 核</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  name: "recependAuditAction",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dialogBox: false,
      submitLoading: false,
      // 是否仅查看明细（true：不显示审核表单和审核按钮）
      isView: false,
      auditRemarkRequired: window.global_config.auditRemarkRequired,
      // 审核提交数据
      sendDataInfo: {
        auditState: 1,
        businessId: "",
        auditRemark: "",
      },
      // 主表数据
      dataInfo: {},
      // 明细列表
      detailList: [],
      // 状态0初始，1已提交，2审核通过，-1审核驳回
      auditStateList: [{
        key: 0,
        value: "初始"
      }, {
        key: 1,
        value: "已提交"
      }, {
        key: 2,
        value: "审核通过"
      }, {
        key: -1,
        value: "审核驳回"
      }],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 获取状态名称
    getAuditStateName(val) {
      let item = this.auditStateList.find(i => i.key == val);
      return item ? item.value : "";
    },
    // 打开抽屉 dataInfo: 主表行数据 isView: 是否仅查看明细
    openBox(dataInfo, isView = false) {
      this.isView = isView;
      this.dataInfo = JSON.parse(JSON.stringify(dataInfo));
      this.detailList = [];
      this.sendDataInfo.auditState = 1;
      this.sendDataInfo.auditRemark = "";
      this.sendDataInfo.businessId = [this.dataInfo.rpid];
      this.dialogBox = true;
      this.getDetailList();
    },
    // 关闭抽屉
    closeBox() {
      this.dialogBox = false;
    },
    // 获取明细列表
    async getDetailList() {
      let responseData = await this.$http.recependDetail({
        rpid: this.dataInfo.rpid,
      });
      if (responseData.status == 200) {
        this.detailList = responseData.result || [];
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 提交审核
    async submitDataAction() {
      if (this.auditRemarkRequired && !this.sendDataInfo.auditRemark) {
        this.$message({
          message: "请输入审批意见",
          type: "warning",
        });
        return;
      }
      this.submitLoading = true;
      let responseData = await this.$http.addTaskReview(this.sendDataInfo);
      this.submitLoading = false;
      if (responseData.status == 200) {
        this.$message({
          type: "success",
          message: "操作成功",
        });
        this.dialogBox = false;
        this.$parent.getDataList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.drawer_content {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.drawer_title {
  height: 45px;
  line-height: 45px;
  padding: 0 20px;
  border-bottom: 1px solid #e4e7ed;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.drawer_title .el-icon-close {
  cursor: pointer;
  font-size: 20px;
}

.drawer_body {
  flex: 1;
  overflow-y: auto;
  padding: 15px 20px;
}

.detail_table {
  flex-shrink: 0;
}

.audit_form {
  margin-top: 15px;
}

/* 区块标题（参考 activityAction.vue） */
.title_box {
  padding: 12px 16px;
  font-weight: bold;
  border-bottom: 1px solid #e4e7ed;
  margin: 15px -20px 10px;
  padding-left: 20px;
}

.audit_form .el-textarea {
  width: 100%;
}

.drawer_footer {
  padding: 10px 20px;
  border-top: 1px solid #e4e7ed;
  text-align: center;
  flex-shrink: 0;
}
</style>
